
import { mixins, Options } from 'vue-class-component';
import { IToken } from '@/api/models/token';
import { formatMoney } from '@/api/shopify/formatMoney';
import ShopifyClient from '@/api/shopify/shopify';
import LazyImage from '@/components/LazyImage.vue';
import MTokenCartDelete from '@/components/shopify/MTokenCartDelete.vue';
import CheckoutWidgetMixin from '@/mixins/checkoutWidget';

@Options({
  components: {
    LazyImage,
    MTokenCartDelete
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    camapignId: {
      type: Number,
      required: true
    },
    token: {
      type: Object,
      required: true
    },
    productId: {
      type: Number,
      required: true
    },
    quantity: {
      type: Number,
      required: true
    },
    productHandle: {
      type: String,
      required: true
    }
  }
})
export default class MTokenCartItem extends mixins(CheckoutWidgetMixin) {
  readonly id: number;
  readonly campaignId: number;
  readonly token: IToken;
  readonly productId: number;
  readonly quantity: number;
  readonly productHandle: string;

  shopifyClient = new ShopifyClient();

  product: {
    featured_image: string;
    formattedPrice: number;
    url: string;
    title: string;
  } | null = null;

  totalFormattedPrice: string | null = null;

  async created() {
    const product = await this.shopifyClient.getProduct(this.productHandle);
    product.formattedPrice = formatMoney(product.price);
    this.product = product;

    this.totalFormattedPrice = formatMoney(product.price * this.quantity);
  }
}
